import { ReactComponentManifest } from "web/entrypoints/common/setup";
import { TheEdit } from "web/react/pages/the-edit";
import withRedux from "web/react/redux-provider";

export const theEditComponents: ReactComponentManifest = {
    TheEdit: withRedux(TheEdit),
};
